export default "__VITE_ASSET__RSUMVA25__"